<script>
import { mapGetters, mapActions } from 'vuex';
import { Field, Form } from 'vee-validate';
import * as Yup from 'yup';

import VInput from '@/components/Common/VInput';

export default {
  name: 'PopupUsual',
  components: {
    VInput,
    VeeForm: Form,
    VeeField: Field,
  },
  data() {
    return {
      name: '',
      phone: '',
      comment: '',
    };
  },
  setup() {
    const schema = Yup.object().shape({
      name: Yup.string().required(),
      phone: Yup.string().required(),
    });

    return {
      schema,
    };
  },
  computed: {
    ...mapGetters({
      allShowedOverlays: 'Popups/allShowedOverlays',
      titlePopup: 'Popups/titlePopup',
    }),

    isShowedPopup() {
      return this.allShowedOverlays?.includes('order-call-with-message');
    },

    formData() {
      return {
        name: this.name,
        phone: this.phone,
        comment: this.comment,
        action: 'order-call-whith-message',
      };
    },
  },
  methods: {
    ...mapActions({
      togglePopup: 'Popups/togglePopup',
      send: 'FormData/send',
    }),

    closePopup() {
      this.togglePopup('order-call-with-message');
    },
    onSubmit(value, actions) {
      this.send(this.formData);
      this.closePopup();
      this.togglePopup('popup-message');
      this.reset();
      setTimeout(() => {
        actions.resetForm();
      }, 1000);
    },
    reset() {
      this.name = '';
      this.phone = '';
      this.comment = '';
    },
  },
};
</script>

<template>
  <div
    class="popup-new"
    :class="{'opacity-100 visible': isShowedPopup}"
    @click.self="closePopup"
  >
    <div class="popup-new-inner">
      <div class="w-full">
        <div class="flex items-center justify-between w-full">
          <p
            class="title-h2 pr-2 mb-6"
            v-html="titlePopup ? titlePopup : 'Заказать звонок'"
          ></p>
          <div
            class="popup-new__close mb-3.5 md:mb-7"
            @click="closePopup"
          ></div>
        </div>
        <vee-form
          :validation-schema="schema"
          novalidate
          class="grid grid-cols gap-y-4"
          @submit="onSubmit"
        >
          <vee-field
            v-slot="{ handleChange, errorMessage }"
            name="name"
          >
            <v-input
              v-model="name"
              type="text"
              placeholder="Ваше имя*"
              name="name"
              :error="errorMessage"
              @update:modelValue="handleChange"
            />
          </vee-field>

          <vee-field
            v-slot="{ handleChange, errorMessage }"
            name="phone"
          >
            <v-input
              v-model="phone"
              type="phone"
              format="phone"
              placeholder="Номер телефона*"
              :error="errorMessage"
              @update:modelValue="handleChange"
            />
          </vee-field>

          <textarea
            v-model="comment"
            placeholder="Комментарий"
            class="w-full p-3 text-gray-600 border border-color-gray rounded-brand cursor-pointer resize-none"
          ></textarea>
          <div>
            <button
              type="submit"
              class="col-auto sm:col-start-1 sm:col-end-3 button button_green button_big w-full"
            >Продолжить</button>
          </div>
        </vee-form>
      </div>
    </div>
  </div>
</template>
